import { PluginType } from '../../domain';
export var facebookApiRelativePath = "/facebook";
export var createFacebookApi = function (baseUrl, http) {
    var apiUrl = "".concat(baseUrl).concat(facebookApiRelativePath);
    return {
        goToConnectFacebookPage: function (pathName) {
            window.location.href = "".concat(apiUrl, "/auth?redirectUrl=").concat(window.location.origin).concat(pathName || window.location.pathname);
        },
        connectFacebookPage: function (dto) {
            return http.post("".concat(apiUrl, "/pages"), dto);
        },
        getAccountFacebookPages: function (dto) {
            return http.get("".concat(apiUrl, "/pages?code=").concat(dto.code, "&redirectUri=").concat(window.location.origin).concat(window.location.pathname));
        },
        getConnectedFacebookPages: function (dto) {
            return http.get("".concat(apiUrl, "/connections?type=").concat(PluginType.FACEBOOK_PAGE, "&checkTokenStatus=").concat(!!(dto === null || dto === void 0 ? void 0 : dto.checkTokenStatus)));
        },
        removeConnectedFacebookPage: function (dto) {
            return http.delete("".concat(apiUrl, "/connections/").concat(dto.id));
        },
        updateConnectedFacebookPage: function (dto) {
            return http.put("".concat(apiUrl, "/connections/").concat(dto.id), dto);
        },
        getFacebookTokensStatus: function (dto) {
            var pagesParam = dto.pages ? "pages=".concat(dto.pages.join(',')) : '';
            var onlyInvalidParam = dto.onlyInvalid ? "onlyInvalid=true&" : '';
            var queryParams = (onlyInvalidParam || pagesParam) ? "?".concat(onlyInvalidParam).concat(pagesParam) : '';
            return http.get("".concat(apiUrl, "/connections/status").concat(queryParams));
        },
    };
};
//# sourceMappingURL=index.js.map